import { z } from 'zod';
import {
  seasonEnum,
  checklistRunStatusEnum,
  checklistRunItemStatusEnum,
} from './enums.ts';

/**
 * Zod schemas for the checklist surface — shared between Worker
 * validation and the React Hook Form resolvers in the web app.
 */

export const createRunInput = z.object({
  templateId: z.string().min(1),
  year: z.number().int().min(2000).max(3000).optional(),
  season: seasonEnum.optional(),
  title: z.string().min(1).max(200).optional(),
});
export type CreateRunInput = z.infer<typeof createRunInput>;

export const patchRunInput = z.object({
  status: checklistRunStatusEnum.optional(),
  notes: z.string().max(8000).nullable().optional(),
  title: z.string().min(1).max(200).optional(),
});
export type PatchRunInput = z.infer<typeof patchRunInput>;

export const patchRunItemInput = z.object({
  status: checklistRunItemStatusEnum.optional(),
  notes: z.string().max(2000).nullable().optional(),
});
export type PatchRunItemInput = z.infer<typeof patchRunItemInput>;

export const createTemplateItemInput = z.object({
  label: z.string().min(1).max(200),
  description: z.string().max(2000).nullable().optional(),
  required: z.boolean().optional(),
});
export type CreateTemplateItemInput = z.infer<typeof createTemplateItemInput>;

export const createTemplateInput = z.object({
  title: z.string().min(1).max(200),
  slug: z
    .string()
    .min(1)
    .max(120)
    .regex(/^[a-z0-9-]+$/, 'slug must be kebab-case lowercase'),
  domainId: z.string().min(1),
  description: z.string().max(2000).nullable().optional(),
  season: seasonEnum.optional(),
  recurrenceRule: z.string().max(64).nullable().optional(),
  items: z.array(createTemplateItemInput).min(1).max(200),
});
export type CreateTemplateInput = z.infer<typeof createTemplateInput>;

// Patch is structurally identical to create (full-replace semantics)
// but kept as its own export so we can layer patch-only constraints
// later without churning the create schema.
export const patchTemplateInput = createTemplateInput;
export type PatchTemplateInput = z.infer<typeof patchTemplateInput>;
